import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import HomeNavBar from './HomeNavBar';
import LoggedInHeader from './LoggedInHeader';

const ConditionalNavBar = () => {
  const { isAuthenticated } = useAuth();

  // Show logged in header for all authenticated users
  if (isAuthenticated) {
    return <LoggedInHeader />;
  }

  // Show public navbar for non-authenticated users
  return <HomeNavBar />;
};

export default ConditionalNavBar;